module.exports = __webpack_public_path__ + "static/media/more.5d14e7e5.svg";